// 显表类型设置
import React, { useEffect, useState, useRef } from 'react'
import { theme, Card, Form, Input, Button, App } from 'antd';
import { SetPassword } from "@/server/home"; // 引入axios
import { useNavigate } from 'react-router-dom'

function ChangePassword() {
  const navigate = useNavigate();//路由跳转
  const { message } = App.useApp();

  const {
    token: { colorText },
  } = theme.useToken(); //获取主题颜色
  const token = localStorage.getItem('dock_token');
  const form = useRef();
  // const [form] = Form.useForm();

  const [new_password, SetNewPassword] = useState('');
  const [confirm_password, SetConfirmPassword] = useState('');

  const onFinish = async (values) => {
    let res = await SetPassword({
      access_token: token,
      password: values.old_password,
      new_password: values.new_password
    })
    if (res.ret === 200) {
      if (res.data.is_alter) {
        message.success('修改密码成功，即将返回登陆页面');
        setTimeout(() => {
          navigate('/login')
        }, 1500)
      } else {
        message.error('修改密码失败');
      }
    }

  }

  const onFinishFailed = (errorInfo) => {
    console.log('验证失败Failed:', errorInfo);
  }

  //在函数组件中，组件加载完成后执行
  useEffect(() => {

  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mar24 flex" >
      <Form
        style={{ color: '#fff !import' }}
        ref={form} name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="原密码"
          name="old_password"
          rules={[
            {
              required: true,
              message: '请输入原密码',
            },
            {
              min: 6, message: '密码至少6位'
            }
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="新密码"
          name="new_password"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入新密码',
            },
            {
              min: 6, message: '密码至少6位'
            }
          ]}
        >
          <Input.Password
            value={new_password}
            onChange={(value) => {

              SetNewPassword(value.target.value);
            }}
          />
        </Form.Item>

        <Form.Item
          label="确认密码"
          name="confirm_password"
          validateTrigger="onBlur"
          required
          rules={[
            { required: true, message: "请输入确认密码" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("两次密码输入不一致"));
              },
            })
          ]}
        >
          <Input.Password
            value={confirm_password}
            onChange={(value) => {
              SetConfirmPassword(value.target.value);
            }} />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 8,
            span: 16,
          }}
        >
          <Button type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
export default ChangePassword